import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
export const NAMING_CONVENTION_PREFERENCE_KEY = 'customPDFReports_namingConvention';
export const DESIGNATION_TYPE_NAME_MAPPING = {
    [CustomPDFReportDesignation.DRAFT]: 'Draft',
    [CustomPDFReportDesignation.DELIVERABLE]: 'Deliverable',
};
// Validator parameters
export const REPORT_CUSTOM_FIELD_MAX_LENGTH = 255; // Update to match backend limitation
export const REPORT_CONTACT_EMAIL_MAX_LENGTH = 255;
export const REPORT_CONTACT_PHONE_MAX_LENGTH = 20;
export const REPORT_CONTACT_URL_MAX_LENGTH = 150;
export const REPORT_PREPARED_FOR_MAX_LENGTH = 50;
export const REPORT_ORGANIZATION_MAX_LENGTH = 50;
export const REPORT_TITLE_MAX_LENGTH = 150;
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX = 5;
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN = 2;
export const REPORT_TYPE_OPTIONS = [
    {
        label: '1 Security',
        value: '1 Security',
        checked: true,
    },
    {
        label: '2 Securities',
        value: '2 Securities',
        checked: true,
    },
    {
        label: '3+ Securities',
        value: '3+ Securities',
        checked: true,
    },
];
export const REPORT_CATEGORY_OPTIONS_DEPRECATED = [
    {
        label: 'Comparison',
        value: 'Comparison',
        checked: true,
    },
    {
        label: 'Overview',
        value: 'Overview',
        checked: true,
    },
    {
        label: 'Multi-Comparison',
        value: 'Multi-Comparison',
        checked: true,
    },
    {
        label: 'Tearsheet',
        value: 'Tearsheet',
        checked: true,
    },
];
